<div class="color-circle" [ngStyle]="{ background: color.code }" [ngClass]="{ white: color.key === 'White', active: active }"></div>
